import React from 'react';
import { Radio, RadioGroup, FormControlLabel, Grid } from '@mui/material';
import '../../styles/parameters.scss';

function ChargeBalance(props) {
  const { handleChangeChargeBalance, balanceObj = {}, translateObject } = props;
  const { cb_cation, cb_anion } = balanceObj;
  return (
    <div className="charge-balance-modal">
      <div className="charge-balance-header sansW4SeLig no_drag S_Regular">{translateObject('Select Ion for Charge Balance')}</div>
      <Grid container>
        <Grid item xs={6}>
          <div className="modal-form-control">
            <div className="radio-group">
              <label className="cb-header-text sansW4SeLig no_drag M_Regular">{translateObject('Cation')}</label>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="radio-group-container no_drag S_Regular"
                value={cb_cation}
                onChange={handleChangeChargeBalance}>
                <FormControlLabel
                  name="cb_cation"
                  value="Na+"
                  control={<Radio />}
                  label="Sodium"
                  labelPlacement="start"
                  className='ml-0 sansW4SeLig Forground-Text-Label'
                  style={{ 'marginRight': '1%' }}
                />
                <FormControlLabel
                  name="cb_cation"
                  value="Mg++"
                  control={<Radio />}
                  label="Magnesium"
                  labelPlacement="start"
                  className='ml-0 mr-0 sansW4SeLig S_Regular Forground-Text-Label'
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
        <div className="verticalLine" />
        <Grid item xs={6}>
          <div className="modal-form-control">
            <div className="radio-group mr-4">
              <label className="cb-header-text sansW4SeLig no_drag M_Regular">{translateObject('Anion')}</label>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="radio-group-container no_drag S_Regular"
                value={cb_anion}
                onChange={handleChangeChargeBalance}>
                <FormControlLabel
                  name="cb_anion"
                  value="Cl-"
                  control={<Radio />}
                  label="Chloride"
                  labelPlacement="start"
                  className='ml-0 sansW4SeLig'
                  style={{ 'marginRight': '1%' }}
                />
                <FormControlLabel
                  name="cb_anion"
                  value="SO4--"
                  control={<Radio />}
                  label="Sulphate"
                  labelPlacement="start"
                  className='ml-0 mr-0 sansW4SeLig'
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ChargeBalance;
